module.exports = __webpack_public_path__ + "8ea983c582204ef87b48120ee00ed57d.svg";